
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sender/[...slug]",
      function () {
        return require("private-next-pages/sender/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sender/[...slug]"])
      });
    }
  